export default "__VITE_ASSET__JT5G0CtK__"